import type { BoggleRunLedgerPhase } from '~/boggle/engine/standard/types'
import type { BoggleCompletedRunPhase } from '~/boggle/progress/types'

/** Canonical ledger/completed-run phase for an active meter burst drain window. */
export const BOGGLE_METER_BURST_LEDGER_PHASE = 'meter-burst' as const

/** @deprecated Legacy phase value on runs recorded before runFactsVersion 5. */
export const BOGGLE_LEGACY_GOLD_RUSH_LEDGER_PHASE = 'gold-rush' as const

export type BoggleMeterBurstReadableFacts = {
  burstActiveAtAcceptance?: boolean
  duringMeterBurstWindow?: boolean
  /** @deprecated runFactsVersion < 5 */
  duringTimerEndGoldRushWindow?: boolean
  /** @deprecated runFactsVersion < 5 */
  goldRushActiveAtAcceptance?: boolean
  meterBurstActiveAfter?: boolean
  /** @deprecated runFactsVersion < 5 */
  meterGoldRushActiveAfter?: boolean
}

export type BoggleMeterBurstLedgerPhase =
  | typeof BOGGLE_LEGACY_GOLD_RUSH_LEDGER_PHASE
  | typeof BOGGLE_METER_BURST_LEDGER_PHASE
  | 'overtime'

export function getDuringMeterBurstWindow(entry: BoggleMeterBurstReadableFacts): boolean {
  return entry.duringMeterBurstWindow ?? entry.duringTimerEndGoldRushWindow ?? false
}

export function getBurstActiveAtAcceptance(entry: BoggleMeterBurstReadableFacts): boolean {
  return entry.burstActiveAtAcceptance ?? entry.goldRushActiveAtAcceptance ?? false
}

export function getMeterBurstActiveAfter(entry: BoggleMeterBurstReadableFacts): boolean {
  return entry.meterBurstActiveAfter ?? entry.meterGoldRushActiveAfter ?? false
}

export function isMeterGainExcludedForMeterBurst(entry: BoggleMeterBurstReadableFacts): boolean {
  return getDuringMeterBurstWindow(entry) || getBurstActiveAtAcceptance(entry)
}

export function isMeterBurstLedgerPhase(
  phase: BoggleMeterBurstLedgerPhase | BoggleCompletedRunPhase,
): boolean {
  return phase === BOGGLE_METER_BURST_LEDGER_PHASE || phase === BOGGLE_LEGACY_GOLD_RUSH_LEDGER_PHASE
}

export function normalizeMeterBurstLedgerPhaseForRead(
  phase: BoggleRunLedgerPhase,
): typeof BOGGLE_METER_BURST_LEDGER_PHASE | 'overtime' {
  return isMeterBurstLedgerPhase(phase) ? BOGGLE_METER_BURST_LEDGER_PHASE : 'overtime'
}
